const ITEMS = [
  "FALL ASLEEP FASTER", "QUIET A RACING MIND", "NO PILLS OR APPS", "7-NIGHT PROTOCOL",
  "3AM PLAYBOOK INCLUDED", "INSTANT PDF DOWNLOAD", "30-NIGHT GUARANTEE", "WAKE UP RESTORED",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-[#0e131f] py-5">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-lg font-bold uppercase tracking-[0.18em] text-slate-200 sm:text-xl">{item}</span>
            <span className="mx-8 font-mono text-cyan-400/70">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
